import { useState } from "react";
import { ModalMessageSimple } from "@/common/components/ModalMessageSimple";
import { DisableTmaisUserModal } from "./DisableTmaisUserModal";
import { EnableTmaisUserModal } from "./EnableTmaisUserModal";
import { TmaisUserData } from "@/features/tmaisUsers/types/tmaisUsers.type";

interface BlockUnblockTmaisUserProps {
  tmaisUser?: TmaisUserData;
}

const BlockUnblockTmaisUser = ({ tmaisUser }: BlockUnblockTmaisUserProps) => {
  const [messages, setMessages] = useState<string[] | boolean>(false);

  const isDisabled = tmaisUser?.status === 'disabled';

  return (
    <>
      {!isDisabled ? (
        <DisableTmaisUserModal tmaisUserId={tmaisUser?.id} setMessages={setMessages} />
      ) : (
        <EnableTmaisUserModal tmaisUserId={tmaisUser?.id} setMessages={setMessages} />
      )}

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError
        />
      )}
    </>
  );
};

export default BlockUnblockTmaisUser;
